import { User } from 'src/store/models/index.js'

const fetchFamilyAndGetUser = async (store) => {
  await store.dispatch('users/getFamily')
  return store.getters['users/me']
}

export default async function timetableEntity ({ to, store }) {
  const allowedParameters = ['event-creation', 'event-categories', 'event-locations', 'event-participants']
  if (Object.keys(to.query).find(key => allowedParameters.includes(key))) return

  if (!to.params.entity && !to.params.id) {
    // wait for user fetch if user's not loaded - if user has a child -> go to child timetable
    const initialUser = await User.waitForUserFetch()

    // if user it not fetch go to news
    if (!initialUser) return

    const userFetchNotComplete = initialUser.type === 'PARENT' && !initialUser.childs.length
    // refetch family if user is not complete
    const user = userFetchNotComplete ? await fetchFamilyAndGetUser(store) : initialUser
    const firstChild = user.childs?.filter(el => el.grade_id)[0] || user.childs[0]
    const userId = user.shortcut_id || !user.childs.length ? user.id : firstChild.id
    if (to.name === 'timetable') return
    return { name: 'timetable', params: { entity: 'users', id: userId }, query: {...to.query} }
  }

  const { entity, id } = to.params
  if (entity !== 'users') return
  const user = User.find(id)

  // todo: maybe optimize and load user
  if (!user) return
  if (user.grade_id || user.shortcut_id) return
  if (to.name === 'timetableMissing' && entity && id) return // prevent endless loop

  const hasSwitchedAccountsParam = Object.keys(to.query).includes('switchedAccounts')
  return { name: 'timetableMissing', params: { entity, id }, query: hasSwitchedAccountsParam ? {...to.query} : {} }
}
